var map = {
	"./en/1-1/googleplay.png": 52995,
	"./fi/1-1/googleplay.png": 78693,
	"./in/1-1/googleplay.png": 34991,
	"./th/1-1/googleplay.png": 83656,
	"./tw/1-1/googleplay.png": 5065,
	"./zh/1-1/googleplay.png": 11178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70717;